import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import env from '@travel/env';
import useMemberKeepAlive from '@travel/traveler-core/hooks/useMemberKeepAlive';

import Banner from 'components/Banner';
import Layout from 'components/Layout';
import useHeaderEvents from 'hooks/useHeaderEvents';
import ErrorPage from 'pages/ErrorPage';
import { refreshAuthCode } from 'store/authCode/actions';
import { getIsLoggedIn } from 'store/authCode/selectors';
import { getIsAPIError } from 'store/commonError/selectors';
import InfoTags from './components/infoTags';
import SEO from './components/SEO';

import { getSEOData } from 'store/seo/selectors';

import styles from '../style/app.module.scss';

if (env('UNIVERSAL_APP_DATE')) {
  const mockDate = require('mockdate');
  mockDate.set(new Date(env('UNIVERSAL_APP_DATE') as string));
}

const App = (props: { children: React.ReactNode }) => {
  const dispatch = useDispatch();
  const seoData = useSelector(getSEOData);
  useHeaderEvents();

  const isAPIError = useSelector(getIsAPIError);
  const isLoggedIn = useSelector(getIsLoggedIn);
  // refresh token
  const refreshTokenHookCallback = useCallback(() => {
    dispatch(refreshAuthCode());
  }, [dispatch]);

  useMemberKeepAlive(isLoggedIn, refreshTokenHookCallback);

  let content = props.children;

  if (isAPIError) content = <ErrorPage />;

  return (
    <div id="app" data-testid="app-wrapper" className={styles.appWrapper}>
      <SEO {...seoData} />
      <Banner />
      <InfoTags />
      <Layout className={styles.layout}>{content}</Layout>
    </div>
  );
};

export default App;
